import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Paths from '../../common/Paths'
import ServicesPage from '../../Pages/ServicesPage/ServicesPage'
import ContactPage from '../../Pages/ContactPage/ContactPage'
import HomePage from '../../Pages/HomePage/HomePage'

const Router = () => (
  <Routes>
    <Route path={Paths.home} element={<HomePage />} />
    <Route path={Paths.services} element={<ServicesPage />} />
    <Route path={Paths.contact} element={<ContactPage />} />

    <Route path={Paths.wild} element={<HomePage />} />
  </Routes>
)


export default Router